export const _proshopProductClass = {
  availableinshop: {
    type: 'string',
    title: 'Näytetäänkö verkkokaupassa',
    oneOf: [
      { const: 'true', title: 'Kyllä' },
      { const: 'false', title: 'Ei' },
    ],
  },
  displayName: { type: 'string', title: 'Asiakkaille näkyvä nimi' },
  description: { type: 'string', title: 'Kuvaus' },
  productcategory: { type: 'string', title: 'Tuotekategoria', oneOf: [] },
  brand: { type: 'string', title: 'Valmistaja', oneOf: [] },
  producttype: { type: 'string', title: 'Tuotetyyppi' },
}

export const _proshopProductClassDeps = {
  availableinshop: {
    oneOf: [
      {
        properties: {
          availableinshop: {
            enum: ['true'],
          },
          vat: {
            type: 'number',
            title: 'ALV',
            oneOf: [
              { const: 0, title: '0%' },
              { const: 10, title: '10%' },
              { const: 13.5, title: '13,5%' },
              { const: 14, title: '14%' },
              { const: 24, title: '24%' },
              { const: 25.5, title: '25,5%' },
            ]
          },
          image: { type: 'string', title: 'Verkkokaupan tuotekuva', items: { type: 'object', images: [] }, minaspectratio: 1 },
          // The gallery, main image included. `image` stays the main image and is what the
          // webshop reads today, so it is left untouched.
          // Deliberately no default, no minItems and not required: any of those would make
          // rjsf write images: [] into every product that is merely opened and saved.
          // `library` is the injection slot for the media library (see ProshopProducts).
          images: {
            type: 'array',
            title: 'Verkkokaupan kuvagalleria',
            items: { type: 'object', library: [] },
            minaspectratio: 1,
          },
          variations: {
            title: '',
            description: 'Hintavaihtoehdot',
            type: 'array',
            items: {
              type: 'object',
              properties: {
                name: { type: 'string', title: 'Nimi' },
                price: { type: 'number', title: 'Hinta' },
                productCode: { type: 'string', title: 'Tuotekoodi' },
                amount: { type: 'number', title: 'Määrä' },
                deliveryCost: { type: 'number', title: 'Toimituskulu (korvaa yleisen porrastuksen, korkein voittaa)' },
              },
            },
          },
          nextarrivaldate: { type: 'string', format:'date', title: 'Saapumispäivä' },
          accounting: { type: 'string', title: 'Kirjanpidontili' },
        }
      },
      {
        properties: {
          availableinshop: {
            enum: ['false'],
          },
        }
      }
    ]
  },
}

export const _proshopProductUISchema = {
  description: {
    'ui:widget': 'editorWidget',
  },
  image: {
    'ui:widget': 'imageWidget',
  },
  images: {
    'ui:widget': 'multiImageWidget',
  },
  vat: {
    'ui:enumDisabled': [10, 14, 24],
  },

}


export const _proshopBrandClass = {
  displayName: { type: 'string', title: 'Nimi' },
  description: { type: 'string', title: 'Kuvaus' },
  image: { type: 'string', title: 'Kuva', items: { type: 'object', images: [] }, minaspectratio: 1 },
}

export const _proshopBrandUISchema = {
  description: {
    'ui:widget': 'editorWidget',
  },
  image: {
    'ui:widget': 'imageWidget',
  }
}

export const _proshopProductCategoryClass = {
  displayName: { type: 'string', title: 'Nimi' },
}

export const _proshopProductCategoryUISchema = {}
